import { Rocket } from 'iconoir-react';
import { FC } from 'react';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Button } from '@savgroup-front-common/primitive/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@savgroup-front-common/primitive/ui/tooltip';

import { useChoosePlanContext } from '../../ChoosePlanDrawer/ChoosePlanDrawer.context';

import messages from './messages';

export const UpgradePlanButton: FC = () => {
  const { handleDrawerOpen } = useChoosePlanContext();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="sm"
          onClick={() => handleDrawerOpen()}
          className="gap-1.5"
        >
          <Rocket />
          <span className="hidden xl:inline">
            <SafeFormattedMessageWithoutSpread
              message={messages.upgradeButton}
            />
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent className="xl:hidden">
        <SafeFormattedMessageWithoutSpread message={messages.upgradeButton} />
      </TooltipContent>
    </Tooltip>
  );
};
